var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.901 2.67188C12.1112 2.67188 8.00399 7.21655 8.00399 11.5689V14.3743C8.00399 15.2827 7.62994 16.6453 7.16237 17.4201L5.4658 20.2522C4.4238 22.0022 5.14518 23.9526 7.06886 24.5938C13.4544 26.7179 20.361 26.7179 26.7465 24.5938C28.55 23.9927 29.3248 21.882 28.3496 20.2522L26.653 17.4201C26.1854 16.6453 25.8114 15.2693 25.8114 14.3743V13.5689",
    stroke: "#292D32",
    strokeWidth: 2.00383,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9363 10.6978C25.4216 10.6978 27.4363 8.68304 27.4363 6.19775C27.4363 3.71247 25.4216 1.69775 22.9363 1.69775C20.451 1.69775 18.4363 3.71247 18.4363 6.19775C18.4363 8.68304 20.451 10.6978 22.9363 10.6978Z",
    fill: "#EE1C29"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3246 25.1414C21.3246 27.586 19.3208 29.5899 16.8761 29.5899C15.6605 29.5899 14.5383 29.0822 13.7368 28.2807C12.9352 27.4792 12.4276 26.357 12.4276 25.1414",
    stroke: "#292D32",
    strokeWidth: 2.00383,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBell);
export default __webpack_public_path__ + "static/media/notification-bell.07b88781.svg";
export { ForwardRef as ReactComponent };